import React, { useState, useEffect } from "react";
import "./ProductFilter.css";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import ReactSlider from "react-slider";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useBaseUrl } from "../../../ApiContext";
import Loading from "../../../Components/Loading/Loading";
import Alert from "../../../Components/Alert/Alert";

export default function ProductFilter() {
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = useBaseUrl();
  const { categorySlug } = location.state || {};
  const { userToken } = useAuth();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [range, setRange] = useState([]);
  const [fullRange, setFullRange] = useState([]);
  const [attributes, setAttributes] = useState(null);
  const [activeThumb, setActiveThumb] = useState(null);
  const [priceAttrString, setPriceAttrString] = useState("");
  const [attrString, setAttrString] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${categorySlug}/attribute-types?filter_page=true`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setAttributes(response.data.attributes);
      } catch (error) {
        console.log("Error during getting filter product attributes", error);
      }
    };
    const fetchPrices = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${categorySlug}/prices`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setFullRange([
          response.data.prices.min_price,
          response.data.prices.max_price,
        ]);
      } catch (error) {
        console.log("Error during getting filter product prices", error);
      }
    };
    if (userToken) {
      fetchAttributes();
      fetchPrices();
    }
  }, [baseUrl, userToken]);

  useEffect(() => {
    if (fullRange.length && attributes) {
      setIsLoading(false);
    }
  }, [fullRange, attributes]);

  const handleRangeChange = (newRange) => {
    setRange(newRange);
    setPriceAttrString(
      `(price__gte,${newRange[0]}),(price__lte,${newRange[1]})`
    );
    localStorage.setItem(
      "price filters",
      `(price__gte,${newRange[0]}),(price__lte,${newRange[1]})`
    );
    const activeThumbIndex = newRange[0] === range[0] ? 1 : 0;
    setActiveThumb(activeThumbIndex);
  };

  const handleAfterChange = () => {
    setActiveThumb(null);
  };

  const handleOpenAttribute = (attributeSlug) => {
    navigate("/subFilter", { state: { categorySlug, attributeSlug } });
  };

  const handleShowProducts = async () => {
    if (priceAttrString || attrString) {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${categorySlug}/product-varients?attributes=${priceAttrString}${
            attrString && priceAttrString && `,`
          }${attrString}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setShowAlert(true);
        setAlertText("در حال فیلتر کردن محصولات...");
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        navigate("/partialProducts", {
          state: {
            categorySlug,
            filteredProducts: response.data.products,
          },
        });
      } catch (error) {
        console.log("Error during getting filtered products", error);
      }
    }
  };

  useEffect(() => {
    const storedAttrStringJSON = localStorage.getItem("attribute filters");
    const storedPriceStringJSON = localStorage.getItem("price filters");
    if (storedAttrStringJSON) {
      setAttrString(storedAttrStringJSON);
    }
    if (storedPriceStringJSON) {
      setPriceAttrString(storedPriceStringJSON);
      const matches = storedPriceStringJSON.match(/(\d+)/g);
      const extractedNumbers = matches.map(Number);
      setRange(extractedNumbers);
    } else {
      setRange(fullRange);
      setPriceAttrString(
        `(price__gte,${fullRange[0]}),(price__lte,${fullRange[1]})`
      );
    }
  }, [fullRange]);

  const handleRemoveFilters = () => {
    localStorage.removeItem("attribute filters");
    localStorage.removeItem("price filters");
    navigate("/partialProducts", {
      state: {
        categorySlug,
        filteredProducts: null,
      },
    });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle partialProductsHeading">فیلتر ها</div>
          <div className="shopFilter centeredFlex">
            {isLoading ? (
              <Loading />
            ) : (
              <div className="shopFilterTop">
                {range.length > 0 && (
                  <div className="priceFilter centeredFlex">
                    <ReactSlider
                      className="priceRange"
                      value={range}
                      min={fullRange[0]}
                      max={fullRange[1]}
                      onChange={handleRangeChange}
                      onAfterChange={handleAfterChange}
                    />
                    <div
                      className="priceRangeOverlayLeft centeredFlex"
                      style={{
                        width: `${
                          ((range[0] - fullRange[0]) /
                            (fullRange[1] - fullRange[0])) *
                          100
                        }%`,
                      }}
                    ></div>
                    <div
                      className="priceRangeOverlayRight centeredFlex"
                      style={{
                        width: `${
                          ((fullRange[1] - range[1]) /
                            (fullRange[1] - fullRange[0])) *
                          100
                        }%`,
                      }}
                    ></div>
                    {activeThumb === 0 && (
                      <div
                        className="bottomRangeTooltip"
                        style={{
                          left: `calc((100%) * ${
                            (range[0] - fullRange[0]) /
                            (fullRange[1] - fullRange[0])
                          })`,
                        }}
                      >
                        {range[0].toLocaleString()}
                      </div>
                    )}
                    {activeThumb === 1 && (
                      <div
                        className="topRangeTooltip"
                        style={{
                          left: `calc((100%) * ${
                            (range[1] - fullRange[0]) /
                            (fullRange[1] - fullRange[0])
                          })`,
                        }}
                      >
                        {range[1].toLocaleString()}
                      </div>
                    )}
                    <div className="priceFullRange centeredFlex">
                      <p>{range[0] > 0 && range[1].toLocaleString()} تومان</p>
                      <p>{range[1] > 0 && range[0].toLocaleString()} تومان</p>
                    </div>
                  </div>
                )}
                {attributes && (
                  <div className="filterAttributes scroll centeredFlex">
                    {" "}
                    {attributes.map((attribute) => (
                      <div
                        key={attribute.slug}
                        className="filterAttribute horizontalBorder centeredFlex"
                        onClick={() => handleOpenAttribute(attribute.slug)}
                      >
                        <div className="filterAttributeTitle centeredFlex">
                          <p>{attribute.name}</p>
                          {attrString && attrString.includes(attribute.slug) && (
                            <div className="activeAttrBullet"></div>
                          )}
                        </div>
                        <MdOutlineArrowBackIos className="filterAttributeIcon" />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className="filterBtns">
              <button
                type="button"
                className="nextQuestion showFilteredProducts"
                onClick={handleShowProducts}
              >
                مشاهده محصولات
              </button>
              <button
                type="button"
                className="nextQuestion removeFilters"
                onClick={handleRemoveFilters}
              >
                حذف فیلتر ها
              </button>
            </div>
          </div>
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
